"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      searchData: {
        page: 1,
        rows: 10 },
      //列表参数
      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      showAdd: false, //是否显示新增弹窗
      tableColumn: [
      {
        prop: 'regionalName',
        label: '服务区域' },

      {
        prop: 'regionalDomainName',
        label: '接口域名' },

      {
        prop: 'mqttDomainName',
        label: 'MQTT域名' },

      {
        prop: 'tcpDomainName',
        label: 'TCP域名' },

      {
        prop: 'remark',
        label: '备注' }],

      //表格表头数据
      tableData: [],
      regionForm: {
        id: '',
        regionalName: '',
        regionalDomainName: '',
        tcpDomainName: '',
        mqttDomainName: '',
        remark: '' },
      //新增||编辑表单
      regionRule: {
        regionalName: [{
          required: true,
          message: '请填写服务区域',
          trigger: ['change', 'blur'] }],

        regionalDomainName: [{
          required: true,
          message: '请填写区域域名',
          trigger: ['blur', 'change'] }],

        mqtt: [{
          required: true,
          message: '请填写MQTT域名',
          trigger: ['blur', 'change'] }],

        tcpDomainName: [{
          required: true,
          message: '请填写TCP域名',
          trigger: ['blur', 'change'] }] },

      //表单验证规则
      regionEdit: false //是否为编辑状态
    };
  },

  mounted: function mounted() {
    this.fetchDomainList();
  },

  methods: {
    /**
              * 获取服务区域域名配置列表
              */
    fetchDomainList: function fetchDomainList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/faServicesRegional/getAll', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchDomainList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchDomainList();
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs.regionForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this3 = this;
      this.$nextTick(function () {
        Object.keys(_this3.regionForm).forEach(function (e) {
          _this3.$set(_this3.regionForm, e, '');
        });
        _this3.$refs.regionForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 提交
        */
    onSaveRegion: function onSaveRegion() {var _this4 = this;
      this.$refs.regionForm.validate(function (valid) {
        if (valid) {
          if (_this4.regionForm.id) {
            //编辑
            var params = Object.assign({}, _this4.regionForm);
            _this4.postData('/api/faServicesRegional/update', params, function (res) {
              _this4.onAddDialogClose();
              _this4.fetchDomainList();
            });
          } else {
            //新增
            var _params = Object.assign({}, _this4.regionForm);
            delete _params['id'];
            _this4.postData('/api/faServicesRegional/save', _params, function (res) {
              _this4.$set(_this4.searchData, 'page', 1);
              _this4.onAddDialogClose();
              _this4.fetchDomainList();
            });
          }
        }
      });
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.regionForm, 'id', row.id);
      this.$set(this.regionForm, 'regionalName', row.regionalName);
      this.$set(this.regionForm, 'regionalDomainName', row.regionalDomainName);
      this.$set(this.regionForm, 'tcpDomainName', row.tcpDomainName);
      this.$set(this.regionForm, 'mqttDomainName', row.mqttDomainName);
      this.$set(this.regionForm, 'remark', row.remark);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this5 = this;
      this.$confirm('确定删除当前域名配置？', '提示', { type: 'warning' }).then(function (res) {
        //删除厂商
        _this5.delData("/api/faServicesRegional/delete/".concat(row.id), {}, function (res) {
          _this5.fetchDomainList();
        });
      }).catch(function (err) {

      });
    } } };exports.default = _default;